module.exports = __webpack_public_path__ + "static/img/1.8549f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/1.png
// module id = 9XEY
// module chunks = 35